import { buildFilter } from './filters/buildFilter';

/** Canonical list of jane-defined row types. */
export const JANE_DEFINED_ROWS = [
  'buy_again_row',
  'sale',
  'best_selling',
  'brand_specials',
  'specials',
  'magic_row',
];

interface CustomRowSetting {
  display_name?: string | null;
  id?: number;
  row_type?: string;
}

export const resolveRowId = (
  placementRowId: number | undefined,
  title: string | undefined,
  customRowSettings: readonly CustomRowSetting[] | undefined
): number | undefined => {
  if (placementRowId) return placementRowId;

  if (title && customRowSettings) {
    const match = customRowSettings.find((r) => r.display_name === title);
    if (match?.id) return match.id;
  }

  return undefined;
};

export const formatFeaturedRow = (
  storeId: number,
  customRowSettings: readonly CustomRowSetting[] | undefined,
  rowId: number
): {
  featuredFilter: string;
  featuredTitle: string;
  isJaneDefined: boolean;
} => {
  const empty = { featuredTitle: '', featuredFilter: '', isJaneDefined: false };

  if (!customRowSettings) return empty;

  const row = customRowSettings.find((r) => r.id === rowId);
  if (!row?.row_type) return empty;

  const isJaneDefined = JANE_DEFINED_ROWS.includes(row.row_type);
  const filterValue = isJaneDefined
    ? row.row_type
    : `${row.row_type}-${storeId}`;

  return {
    featuredTitle: row.display_name || row.row_type,
    featuredFilter: buildFilter('root_types', [filterValue]),
    isJaneDefined,
  };
};
